import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  requestShiftSwap,
  acceptShiftSwap,
  declineShiftSwap,
  fetchShiftSwapRequests,
  fetchShiftSwapRequest,
} from './shiftSwapService';

// Request a shift swap
export const requestShiftSwapThunk = createAsyncThunk(
  'shiftSwap/requestSwap',
  async ({ shiftId, targetEmployeeId }, { rejectWithValue }) => {
    try {
      await requestShiftSwap(shiftId, targetEmployeeId);
      return {
        shiftId,
        targetEmployeeId,
        status: 'pending',
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Accept a shift swap request
export const acceptShiftSwapThunk = createAsyncThunk(
  'shiftSwap/acceptSwap',
  async ({ shiftSwapRequestId }, { rejectWithValue }) => {
    try {
      await acceptShiftSwap(shiftSwapRequestId);
      return { shiftSwapRequestId };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Decline a shift swap request
export const declineShiftSwapThunk = createAsyncThunk(
  'shiftSwap/declineSwap',
  async ({ shiftSwapRequestId }, { rejectWithValue }) => {
    try {
      await declineShiftSwap(shiftSwapRequestId);
      return { shiftSwapRequestId };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Fetch shift swap requests for an employee
export const fetchShiftSwapRequestsThunk = createAsyncThunk(
  'shiftSwap/fetchRequests',
  async ({ venueId, employeeId }, { rejectWithValue }) => {
    try {
      const requests = await fetchShiftSwapRequests(venueId, employeeId);
      return requests;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Cancel a shift swap request (same as decline but for source user)
export const cancelShiftSwapThunk = createAsyncThunk(
  'shiftSwap/cancelSwap',
  async ({ shiftSwapRequestId }, { rejectWithValue }) => {
    try {
      await declineShiftSwap(shiftSwapRequestId);
      return { shiftSwapRequestId };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Fetch a single shift swap request
export const fetchShiftSwapRequestThunk = createAsyncThunk(
  'shiftSwap/fetchRequest',
  async ({ shiftSwapRequestId }, { rejectWithValue }) => {
    try {
      const request = await fetchShiftSwapRequest(shiftSwapRequestId);
      return request;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);